import StudentSummary from './StudentSummary';

export default StudentSummary;
